import React from "react";
import green from "@material-ui/core/colors/green";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";
import classes from "./InvoicesDetails.module.scss";
import CircularProgress from "../../components/CircularProgress";
import InvoiceDetailsMain from "./InvoiceDetailsMain";
import InvoiceDetailsProduct from "./InvoiceDetailsProduct";
import InvoiceDetailsTotal from "./InvoiceDetailsTotal";
import { useTranslation } from "react-i18next";

const styles = (theme) => ({
  buttonProgress: {
    color: green[500],
  },
});

const InvoiceDetails = ({
  open,
  handleRequestClose,
  detailData,
  detailsLoading,
}) => {
  const { t, i18n } = useTranslation();
  return (
    <>
      <div className={classes.root}>
        <Dialog
          open={open}
          onClose={handleRequestClose}
          className={classes.dialogRoot}
          fullWidth
          maxWidth="lg"
        >
          {detailsLoading ? (
            <div style={{ height: "100px" }}>
              <CircularProgress />
            </div>
          ) : (
            <div
              className="w-100 text-center"
              style={{
                maxWidth: "100%",
                borderRadius: "1.6rem",
                direction: i18n.dir(),
              }}
            >
              <div className="w-100 p-4 d-flex justify-content-between">
                <h2>{t("invoices.invoice_description")}</h2>
              </div>
              <Grid
                container
                spacing={2}
                className="p-3"
                style={{ borderRadius: "1.6rem" }}
              >
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <InvoiceDetailsMain
                    detailData={detailData}
                    classes={classes}
                  />
                  <InvoiceDetailsProduct
                    detailData={detailData}
                    classes={classes}
                  />
                  <InvoiceDetailsTotal
                    detailData={detailData}
                    classes={classes}
                  />
                </Grid>
              </Grid>
            </div>
          )}
        </Dialog>
      </div>
    </>
  );
};

export default withStyles(styles)(InvoiceDetails);
